import axios from 'axios';

const httpApiSiga = axios.create({
  baseURL: "https://api.siga.studytravelworkips.com/api/v1"
});

export default httpApiSiga;